module.exports = __webpack_public_path__ + "img/ppp.0bd92a27.svg";